let containerSelector;

export const setGlTooltipDefaultContainer = (selector) => {
  containerSelector = selector;
};

export const getGlTooltipDefaultContainer = () => containerSelector;
